import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function CI() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="ci">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">Hire The Best CodeIgniter Developers
</h2>
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">Hire The Best CodeIgniter Developers At Dave's Brother Technology</h1>
      <p class="lg:w-2/3 mx-auto leading-relaxed text-base">Known for its powerful native interface, CodeIgniter can help you develop apps with vivid and flexible UIs. With CodeIgniter, you can bring beautiful high-performing mobile apps to life. Dave's Brother Technology helps you reap all the benefits that come with CodeIgniter, by getting you the talent that gets the job done!.</p>
    </div>
    <div class="flex flex-col text-center w-full mb-20">
     
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Why Choose Dave's Brother Technology To Hire CodeIgniter Developers?
</h1>
     
    </div>
    <div class="flex flex-wrap">
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">24x7 Unwavering Support</h2>
        <p class="leading-relaxed text-base mb-4">Fretting about loading time issues? Don't worry! Our CodeIgniter developers will be available to resolve any errors and problems for you instantaneously.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Flexible Hiring</h2>
        <p class="leading-relaxed text-base mb-4">Need CodeIgniter developers for a single project? On Dave's Brother Technology, you can hire a team of developers that will be committed to your project until its completion. What's more? You can vary your team size according to your needs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Save Time & Money</h2>
        <p class="leading-relaxed text-base mb-4">You don't need to break your bank to hire CodeIgniter developers anymore. Dave's Brother Technology smoothens the hiring process for you - It's economical and best suited for startups/SMEs.</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
        <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Customer Is King!</h2>
        <p class="leading-relaxed text-base mb-4">You are our priority. We are resilient about the service we provide and make sure you get to work with the best CodeIgniter developers!</p>
        <a class="text-indigo-500 inline-flex items-center">Learn More
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </a>
      </div>
    </div>
    
  </div>
</section>
<section class="text-gray-600 body-font">
    <div class="flex flex-col text-center w-full mb-20">
     
     <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Benefits Of Choosing CodeIgniter For Your Company

</h1>
    
   </div>
  <div class="container px-5 py-24 mx-auto flex flex-wrap">
    <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
      <img alt="feature" class="object-cover object-center mt-20-px h-300 w-300" src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"/>
    </div>
    <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp; Handling Bugs/Error Handling</h2>
          <p class="leading-relaxed text-base text-gray-900">If you are one of those who wish to develop websites that are flawless and deliver exceptional functionality and design, you need to check out CodeIgniter. A simple user interface is provided that lends a hand in finding any errors or bugs that are preventing the smooth functioning of the website and eventually affecting the user experience.</p>
          
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Customizability</h2>
          <p class="leading-relaxed text-base text-gray-900"> CodeIgniter is the only framework that provides the ease of customizability as compared to the numerous options that are available in the market.Instant error fixing and configuring the files in a simplified form are the reasons that depict the need to rely on CodeIgniter whenever someone is seeking promising web development services.</p>
         
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Security</h2>
          <p class="leading-relaxed text-base text-gray-900">For all those seeking the most secure platform for web development; undoubtedly, CodeIgniter is a perfect choice! The platform offers enhanced security features that are enough to depict the overall reliability of this platform. The different encryption and decryption features have made this platform a lot more reliable than any other platform in the market.</p>
          
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Quick Development</h2>
          <p class="leading-relaxed text-base text-gray-900">Most of the businesses choose CodeIgniter for web development purposes just because it offers quick development services that one can’t expect from any other framework. Thus, it is necessarily crucial to rely on this powerful framework if someone is expecting quick development services without any hassle.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<Footer />
    </>
  );
}